<template>
    <div class="all-section-area">
        <MainHeader />
        <main class="main-content-wrap">
            <PageTitle mainTitle="My Devices" pageTitle="Images" />
            <ImagesDevices />
            <div class="flex-grow-1"></div>
            <FooterArea />
        </main>
    </div>
</template>

<script>
import MainHeader from '../Layouts/MainHeader'
import PageTitle from '../Common/PageTitle'
import ImagesDevices from '../Images/ImagesDevices'
import FooterArea from '../Layouts/FooterArea'

export default {
    name: 'ImagesPage',
    components: {
        MainHeader,
        PageTitle,
        ImagesDevices,
        FooterArea,
    },
    mounted () {
        document.body.classList.add('body-bg-f8faff')
    },
}
</script>